import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import api from '../utils/api';

class SEOMetaData extends React.PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  state = {
    seo: {},
    og: {},
    hreflang: {},
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.props.location.pathname && this.fetchMetaData(this.props.location.pathname);
    }
  }

  fetchMetaData = async path => {
    const response = await api.seoMetaData(path);
    const data = await response.json();

    if (data) {
      const seo = data.seo || {};
      const og = data.og || {};
      const hreflang = data.hreflang || {};
      this.setState({ seo, og, hreflang });
    }
  };

  render() {
    const { og, seo, hreflang } = this.state;

    return (
      <Helmet>
        {seo.title && <title>{seo.title}</title>}
        {seo.description && <meta name="description" content={seo.description} />}
        {seo.keywords && <meta name="keywords" content={seo.keywords} />}

        {og.title && <meta property="og:title" content={og.title} />}
        {og.description && <meta property="og:description" content={og.description} />}
        {og.image && <meta property="og:image" content={og.image} />}

        {hreflang.enurl && <link rel="alternate" hrefLang="en" href={hreflang.enurl} />}
        {hreflang.ruurl && <link rel="alternate" hrefLang="ru" href={hreflang.ruurl} />}
      </Helmet>
    );
  }
}

export default SEOMetaData;



// WEBPACK FOOTER //
// ./src/components/SEOMetaData.js